module.exports = __webpack_public_path__ + "static/media/strikethrough.8c318a81.svg";